import React, {useState} from 'react';
import {View} from 'react-native';
import ReactNativeModal from 'react-native-modal';

import XIcon from '../../../images/brand/svg/icons/X.svg';
import {rewardsMarketingName} from '../../../utils/rewards';
import Button from '../../themed/Button';
import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type Props = {
  onOptOut?: () => void;
};

function OptOutCTA({onOptOut}: Props) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  return (
    <>
      <Button variant="text" color="error" onPress={() => setShowConfirm(true)}>
        OPT OUT OF {rewardsMarketingName.toUpperCase()}
      </Button>

      <ReactNativeModal
        isVisible={showConfirm}
        hasBackdrop
        backdropOpacity={0.75}
        onBackdropPress={() => setShowConfirm(false)}
        onBackButtonPress={() => setShowConfirm(false)}>
        <View style={{backgroundColor: 'white', paddingHorizontal: 20}}>
          <PressableWithOpacityFeedback
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              padding: 20,
              zIndex: 1,
            }}
            onPress={() => {
              setShowConfirm(false);
            }}>
            <XIcon />
          </PressableWithOpacityFeedback>
          <Text variant="heading1">ARE YOU SURE?</Text>
          <Text variant="body2">
            You’re about to deactivate your {rewardsMarketingName} membership.
            You’ll still have access to your account for online shopping, but
            you will no longer be able to access any member benefits. {'\n\n'}Do
            you still wish to opt out of {rewardsMarketingName}?
          </Text>

          <View style={{gap: 16, marginVertical: 40}}>
            <Button
              loading={loading}
              onPress={async () => {
                setLoading(true);
                try {
                  await onOptOut?.();
                } catch (e) {}
                setLoading(false);
                setShowConfirm(false);
              }}>
              {`OPT OUT OF ${rewardsMarketingName.toUpperCase()}`}
            </Button>
            <Button
              variant="outlined"
              onPress={() => {
                setShowConfirm(false);
              }}>
              {`KEEP MY ${rewardsMarketingName.toUpperCase()} MEMBERSHIP`}
            </Button>
          </View>
        </View>
      </ReactNativeModal>
    </>
  );
}

export default OptOutCTA;
